var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1 0 0 1.1 1.59 -1.19)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.28 12c2.51 0 4.55-2.04 4.55-4.55 0-2.51-2.04-4.55-4.55-4.55s-4.55 2.04-4.55 4.55c0 2.51 2.04 4.55 4.55 4.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.91 13.6c-0.511 0-0.997 0.106-1.45 0.283l0.00391 0.0098c-1.45 0.591-2.47 2.01-2.47 3.67v2.92c0 0.345 0.28 0.627 0.625 0.627h13.7c0.345 0 0.625-0.28 0.625-0.625v-2.92c0-1.66-1.02-3.08-2.47-3.67l0.0059-0.0098c-0.45-0.178-0.936-0.283-1.45-0.283z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.add6a97e.svg";
export { ForwardRef as ReactComponent };